import { getVisitId } from "./visitId.es.js";
import "../../../cookieHandler-ac6954c1.js";
import "./adapter.es.js";
import "../../../cookies-04bd2321.js";
import "../../../utils/logger.es.js";
import "../timeOnPage/timeOnPage.es.js";
import "../../../v4-88c20f3b.js";
import "./constants.es.js";
import "./processUrlVisitId.es.js";
import "./utils.es.js";
const analyticsVisitId = () => ({
  name: "analytics-visitId",
  page: ({ payload }) => {
    const ids = payload.properties.ids || {};
    const allIds = { ...ids, visit_id: getVisitId() };
    payload.properties = {
      ...payload.properties,
      ids: allIds
    };
  },
  track: ({ payload }) => {
    const ids = payload.properties.ids || {};
    const allIds = { ...ids, visit_id: getVisitId() };
    payload.properties = {
      ...payload.properties,
      ids: allIds
    };
  }
});
export {
  analyticsVisitId
};
